import { useVpsHostingSectionContent } from './useVpsHostingSectionContent';
import { parseVpsHostingWhyClientsContent } from '../utils/vpsHostingContent';

export const useVpsHostingWhyClientsContent = () =>
  useVpsHostingSectionContent(parseVpsHostingWhyClientsContent);
